import { Component, OnInit } from '@angular/core';
declare var AdminLTE: any;
@Component({
    selector: 'app-dashboard',
    templateUrl: './dashboard.component.html',
    styleUrls: ['./dashboard.component.css']
})
export class DashboardComponent implements OnInit {

    constructor() { }

    ngOnInit() {
        AdminLTE.init();
    }
}



// WEBPACK FOOTER //
// C:/Users/El-Nino/Desktop/coin-alert-test/AngularCoinAlert/src/app/_components/dashboard/dashboard.component.ts